/**
 * Mask phone number for privacy
 * @param phone - Phone number to mask
 * @returns Masked phone number showing only last 4 digits
 */
export const maskPhone = (phone: string): string => {
  if (phone.length <= 4) {
    return phone;
  }
  return '****' + phone.slice(-4);
};

/**
 * Mask email address for privacy
 * @param email - Email address to mask
 * @returns Masked email address
 */
export const maskEmail = (email: string): string => {
  const [name = '', domain = ''] = email.split('@');
  if (name.length <= 4) {
    return '****@' + domain;
  }
  return name.slice(0, 4) + '****@' + domain;
};
